<template>
  <ValidationObserver ref="organizationForm" v-slot="{ invalid, passes }">
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article" class="mb-6">
      <v-form rel="organizationForm" @submit.prevent="passes(save)">
        <v-card class="elevation-1 mb-6 rounded-lg">
          <v-card-title class="pa-7">
            {{ title }}
          </v-card-title>
          <v-card-text class="pl-7 pr-7 pt-7">
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.name"
                  rules="required"
                  outlined
                  dense
                  label="Název"
                  data-cy="name"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <div class="request-label">Administrátor - zobrazení</div>
                <div class="request-value mt-0">
                  <v-checkbox
                    v-model="value.adminEnabled"
                    :label="`${value.adminEnabled ? 'Zapnuto' : 'Vypnuto'}`"
                  ></v-checkbox>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <div class="request-label">Zákazník - zobrazení</div>
                <div class="request-value mt-0">
                  <v-checkbox
                    v-model="value.clientEnabled"
                    :label="`${value.clientEnabled ? 'Zapnuto' : 'Vypnuto'}`"
                  ></v-checkbox>
                </div>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                height="40px"
                min-width="130px"
                color="primary"
                depressed
                :loading="loading"
              >
                Uložit
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-form>
    </v-skeleton-loader>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'SupplierForm',
  props: {
    value: {
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
    }
  },
  methods: {
    save() {
      this.$emit('save', this.value)
    },
  },
}
</script>
